import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import './i18n'
import { DebugProvider } from './shared/DebugContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <React.Suspense fallback="loading">
          <DebugProvider>
            <App />
          </DebugProvider>
        </React.Suspense>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
